import { connect } from 'react-redux';
import { FILL } from '../../../../../redux/actions/app/fill/fill.actions';
import { getGestionnaireInit } from '../../../../../redux/selectors/init/init.selectors';
import { getLoadingEntity } from '../../../../../redux/selectors/ui/ui.selectors';
import PreferencesEmail from './PreferencesEmail';

const mapStateToProps = (state) => ({
    loadingPostFill: getLoadingEntity(state, FILL),
    gestionnaireIsAMO: getGestionnaireInit(state)?.codeBelair === 43397,
});

const PreferencesEmailContainer = connect(mapStateToProps)(PreferencesEmail);

export default PreferencesEmailContainer;
